<template>
  <v-container grid-list-md>
    <v-flex row class="flights" v-if="theseFlights !== null">
      <v-layout row>
        <v-flex grow>
          <v-flex xs12>
            <v-layout row justify-start align-start>
              <v-flex xs2 class="flight_time">
                <h5>Departure</h5>
              </v-flex>
              <v-flex xs3 sm2 class="flight_time">
                <h5>Arrival</h5>
              </v-flex>
              <v-flex xs2 md1 class="flight_time">
                <h5>Fare</h5>
              </v-flex>
              <v-spacer></v-spacer>
            </v-layout>
          </v-flex>
          <v-divider></v-divider>
          <v-flex
            v-for="(flight, index) in theseFlights"
            :value="index"
            :key="index + '_' + flight.flight_info.f_id"
            class="timeslot"
            xs12
          >
            <v-layout row>
              <v-flex xs3>
                <v-card flat class="flight_time">
                  <v-card-text>
                    <div class="label">Departure</div>
                    {{ timeFormat(flight.flight_info.f_start) }}
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs3>
                <v-card flat class="flight_time">
                  <v-card-text>
                    <div class="label">Arrival</div>
                    {{ timeFormat(flight.flight_info.f_start, flight.flight_info.r_id) }}
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12>
                <v-layout>
                  <v-flex class="fare" v-if="flight.fares_available.length >= 1">
                    <v-card
                      v-for="(fare, index2) in flight.fares_available"
                      @click="FlightSelect(index, index2, flight, fare, flightType)"
                      :value="index2"
                      :key="index2"
                      :class="
                        getSelectedClass(
                          index,
                          index2,
                          flightType,
                          flight.fares_available.length,
                          flight,
                          fare
                        )
                      "
                      ripple tile flat
                    >
                      <v-layout
                        v-if="
                          getSelectedClass(
                            index,
                            index2,
                            flightType,
                            flight.fares_available.length,
                            flight,
                            fare
                          ) === 'invalid' && index2 === 0
                        "
                      >
                        <v-flex xs10>
                          Return flights must occur after departing flight.
                        </v-flex>
                      </v-layout>
                      <v-layout
                        v-else-if="
                          getSelectedClass(
                            index,
                            index2,
                            flightType,
                            flight.fares_available.length,
                            flight,
                            fare
                          ) !== 'invalid'
                        "
                        row
                        justify-start
                        align-center
                      >
                        <v-flex xs2>
                          <v-layout row wrap justify-start align-center>
                            <v-flex xs12>
                              <div
                                v-if="isValidFlight(flightType, flight, fare) === true"
                              >
                                <v-icon medium class="not_selected f_icon">
                                  trip_origin
                                </v-icon>
                                <v-icon medium class="selected f_icon">
                                  brightness_1
                                </v-icon>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12>
                          <v-layout row wrap align-content-space-between>
                            <v-flex
                              xs12
                              sm4
                              class="strong"
                              v-if="isValidFlight(flightType, flight, fare) === true"
                            >
															<v-flex v-if="fare.fare_type == 'waitlist'">
																Join Waitlist
															</v-flex>
															<v-flex v-else>
                              	{{ formatPrice(fare.total) }}
															</v-flex>
                            </v-flex>
                            <v-flex grow>
                              {{ fare.label }}
                            </v-flex>
                            <v-flex
                              xs12
                              sm4
                              class="italic"
                              v-if="
                                getSelectedClass(
                                  index,
                                  index2,
                                  flightType,
                                  flight.fares_available.length,
                                  flight,
                                  fare
                                ) !== 'invalid' && fare.fare_type !== 'waitlist'
                              "
                            >
                              <span>
                                {{ fare.seats_av }} Seat<span v-if="fare.seats_av != 1"
                                  >s</span
                                >
                              </span>
                              left
                            </v-flex>
                            <v-flex v-else-if="fare.fare_type === 'waitlist'">
                              
                            </v-flex>
                            <v-flex
                              v-else-if="flight.flight_info.f_status !== 'Call To Book'"
                            >
                              {{
                                flightStatus(
                                  flight.flight_info.f_status,
                                  flight.flight_info.f_start
                                )
                              }}
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <v-flex shrink v-show="mobileDevice === true || col_mode === false">
                        <transition name="slide">
                          <v-card ripple v-if="showFare" class="fare_options">
                            <v-card-text>
                              <FareOptions
                                :fareType="fare.label"
                                :departure="form_fields.dep_loc"
                                :destination="form_fields.dest_loc"
                                :parentClass="
                                  getSelectedClass(
                                    index,
                                    index2,
                                    flightType,
                                    flight.fares_available.length,
                                    flight,
                                    fare
                                  )
                                "
                              />
                            </v-card-text>
                          </v-card>
                        </transition>
                      </v-flex>
                    </v-card>
                  </v-flex>
                  <v-flex v-else>
                    <v-card
                      :class="{ invalid: flight.flight_info.f_status !== 'Scheduled' }"
                      ripple
                      tile
                      flat
                    >
                      <v-layout row justify-start align-center>
                        <v-flex xs10>
                          <v-layout row wrap justify-start align-center>
                            <v-flex xs12 sm12 md12 class="strong pr-2 mr-2">
                              {{ flight.flight_info.f_status }}
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>

								<v-flex class="disabled-fares" v-if="flight.all_fares.length > 0">
									<v-layout
                      v-for="(fare, index3) in flight.all_fares"
                      :value="index3"
                      :key="index3"
											class="fare"
                      ripple tile flat
                    >
										<v-flex class="icon xs2">&nbsp;</v-flex>
										<v-flex xs12>
											<v-layout class="row wrap align-content-space-between">
												<v-flex class="strong price xs12 sm4"><v-flex>{{ formatPrice(fare.total) }}</v-flex></v-flex>
												<v-flex class="label flex grow"><v-flex>{{ fare.label }}</v-flex></v-flex>
												<v-flex class="fare-status xs12 sm4"><v-flex>Sold Out</v-flex></v-flex>
											</v-layout>
										</v-flex>
									</v-layout>
								</v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-container v-else-if="this.departingFlights && this.departingFlights.error">
      <v-layout>
        <v-flex xs12 class="search-error">
          {{ this.departingFlights.error }}
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-else-if="this.returningFlights && this.returningFlights.error">
      <v-layout>
        <v-flex xs12 class="search-error">
          {{ this.returningFlights.error }}
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      v-else-if="loading != true && loading2 != true && form_fields.dest_loc !== 0"
    >
      <v-layout>
        <v-flex xs12>
          <ErrorPage
            label="No Flights Found"
            description="Please change your selection and try again."
            icon="airplanemode_inactive"
          />
        </v-flex>
      </v-layout>
    </v-container>
    <ErrorDialog
      :message="error.details"
      :show="returnError"
      :timeout="5000"
      :callHide="hideErrorDialog"
    />
  </v-container>
</template>

<script>
import ErrorPage from "@/components/pages/ErrorPage.vue";
import ErrorDialog from "@/components/dialogs/ErrorDialog.vue";
import FareOptions from "@/components/forms/sections/FareOptions.vue";
import { createHelpers } from "vuex-map-fields";
import store from "../../../store";
import { EventBus } from "../../../services/EventBus.js";
import dayjs from "dayjs";
import Shared from "@/mixins/Shared";

const { mapFields } = createHelpers({
  getterType: "getField",
  mutationType: "updateField",
});

export default {
  name: "FlightSelect",
  props: ["searchType"],
  created() {
    EventBus.$on("departingFlightsLoaded", () => {
      if (
        this.editMode === true &&
        this.editBookingData !== undefined &&
        this.editBookingData !== null
      ) {
        const selID = this.editBookingData.dep.f_id;
        const departs = this.editBookingData.dep.departs;
        const selFare = this.editBookingData.dep.fare.fare_type;
        const flights = this.departingFlights;
        if (flights !== null) {
          for (let x = 0; x < flights.length; x++) {
            if (flights[x].flight_info.f_id === selID) {
              const fares = flights[x].fares_available;
              for (let y = 0; y < fares.length; y++) {
                if (fares[y].fare_type === selFare) {
                  this.FlightSelect(x, y, flights[x], fares[y], "departing");
                  if (this.editBookingData.ret !== undefined) {
                    this.searchFlights(1);
                  }
                }
              }
            }
          }
        }
      }
    });
    EventBus.$on("returningFlightsLoaded", () => {
      if (this.editMode === true) {
        const selID = this.editBookingData.ret.f_id;
        const departs = this.editBookingData.ret.departs;
        const selFare = this.editBookingData.ret.fare.fare_type;
        const flights = this.returningFlights;
        for (let x = 0; x < flights.length; x++) {
          if (flights[x].flight_info.f_id === selID) {
            const fares = flights[x].fares_available;
            for (let y = 0; y < fares.length; y++) {
              if (fares[y].fare_type === selFare) {
                this.FlightSelect(x, y, flights[x], fares[y], "returning");
              }
            }
          }
        }
      }
    });
  },
  methods: {
    flightStatus(status, start) {
      const s = dayjs(start);
      if (status === "Waitlist") {
        return "call";
      }
      return status;
    },
  },
  data: function () {
    return {
      store: store,
      error: {
        details: "",
      },
      showFare: [],
    };
  },
  mixins: [Shared],
  components: { FareOptions, ErrorDialog, ErrorPage },
};
</script>

<style lang="scss" scoped>
@import "@/styles/flight_search.scss";
</style>
